import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { HttpResource } from './resource/http-resource';

@Injectable({ providedIn: 'root' })
export class BaseHttpService extends HttpResource {
  constructor() {
    super(inject(HttpClient), {
      basePath: '/Cycle'
    });
  }
}
